import { TFunction } from 'i18next';
import { Pricing } from '@maiia/model/generated/model/api-patient/api-patient';

// eslint-disable-next-line import/prefer-default-export
export const HCD_INNER_SECTION_SPACING = 3;

const formatPrice = (price: number | undefined, t: TFunction) => {
  if (price === 0) {
    return t('free');
  }
  if (price && price > 0) {
    return t('price', { value: price });
  }
  return '';
};

export const formatPricing = (pricing: Pricing, t: TFunction) => {
  const { minPrice, maxPrice, price, conventionedActId } = pricing;
  if (conventionedActId) {
    return formatPrice(price, t);
  }

  if (typeof minPrice === 'undefined' || typeof maxPrice === 'undefined') {
    return formatPrice(minPrice ?? maxPrice, t);
  }

  if (minPrice >= 0 && maxPrice >= minPrice) {
    return t('price', {
      value: minPrice !== maxPrice ? `${minPrice} - ${maxPrice}` : minPrice,
    });
  }

  // if we pass here, it means that we have a value not allowed
  // ex: {minPrice: -1, maxPrice: 10}
  return '';
};
